export default __webpack_public_path__ + "static/210528_夏日角色熱更預告_en-375e21f44577d078fcc4d1af8aa3eabf.png";